import { render, staticRenderFns } from "./SystemMessages.vue?vue&type=template&id=436a5965&"
import script from "./SystemMessages.vue?vue&type=script&lang=ts&"
export * from "./SystemMessages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports